import { TypographyOptions } from '@material-ui/core/styles/createTypography';
import { values } from 'ramda';

export const fonts = {
  roboto: 'Roboto',
  default: 'sans-serif',
};

export const typography: TypographyOptions = {
  fontFamily: values(fonts).join(','),
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/theme/typography.ts